import { gql } from '@apollo/client';
const AUTOCOMPLETE_CURRENCIES = gql `
  query AutocompleteCurencies {
    autocomplete {
      id
      currencies {
        edges {
          node {
            id
            name
            isoCode
          }
        }
      }
    }
  }
`;
export default AUTOCOMPLETE_CURRENCIES;
